import { z } from 'zod'
import AdvisorClientContactEntityDtoSchema from './AdvisorClientContactEntityDtoSchema'

export namespace AdvisorClientContactDto {
   export const entitySchema = AdvisorClientContactEntityDtoSchema
   export type entity = z.output<typeof AdvisorClientContactEntityDtoSchema>

   export const createSchema = AdvisorClientContactDto.entitySchema.pick({
      clientId: true,
      firstName: true,
      lastName: true,
      email: true,
      phoneNumber: true,
   })
   export type create = z.output<typeof AdvisorClientContactDto.createSchema>

   export const minimalSchema = AdvisorClientContactDto.entitySchema.pick({
      id: true,
      name: true,
      firstName: true,
      lastName: true,
      email: true,
      status: true,
   })
   export type minimal = z.output<typeof AdvisorClientContactDto.minimalSchema>

   export const updateSchema = AdvisorClientContactDto.entitySchema.pick({
      id: true,
      name: true,
      firstName: true,
      lastName: true,
      email: true,
      clientId: true,
      phoneNumber: true,
      primaryContact: true,
   })
   export type update = z.output<typeof AdvisorClientContactDto.updateSchema>

   export const listSchema = AdvisorClientContactDto.entitySchema
      .pick({
         advisorOrgId: true,
         clientId: true,
      })
      .merge(
         z.object({
            includeHiddenStatus: z.boolean().optional(),
            includeArchivedStatus: z.boolean().optional(),
         })
      )
   export type list = z.output<typeof AdvisorClientContactDto.listSchema>
}
